import { render, staticRenderFns } from "./cable-details-form.component.vue?vue&type=template&id=6456d0c2"
import script from "./cable-details-form.component.ts?vue&type=script&lang=ts&external"
export * from "./cable-details-form.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6456d0c2')) {
      api.createRecord('6456d0c2', component.options)
    } else {
      api.reload('6456d0c2', component.options)
    }
    module.hot.accept("./cable-details-form.component.vue?vue&type=template&id=6456d0c2", function () {
      api.rerender('6456d0c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/detail-forms/cable-details-form/cable-details-form.component.vue"
export default component.exports